import '../App.scss';
import React, { useState, Component } from 'react';
import TextBox from '../components/Atoms/TextBox'
import TopBarAlt from '../components/Organisms/TopBarAlt'
import Heading from '../components/Atoms/Heading'
import { client } from '../client';
import ReactMarkdown from 'react-markdown'




class CV extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      imageURL: '',
      description: '',
      links: []
    }  
  }

   //this is where we receive API calls inside components
   componentDidMount() {
    client.getEntries({
      content_type: "cv"
    })
      .then((response) => {
        this.setState({
          data : response.items[0],
          description: response.items[0].fields.cvDescription,
          imageURL: response.items[0].fields.cvImage.fields.file.url,
          links : response.items[0].fields.cvLinks
        })
        
    })
    .catch(console.error)
  }


render() {

  console.log(this.state.description)

  const {data, imageURL, description, links} = this.state;

  return (
<div className="news-page h-101" >
      <TopBarAlt />
      <Heading cx="bb pa-m" content="CV" headingLevel="h2"/>

      <div className="flex phone-flex-column" style={{minHeight: '500px'}}> 

        <div className="flex-1 items-start br bb flex">
          <img className="w-100 fit-scale-down"src={`${imageURL}?fm=jpg&fl=progressive`}></img>
        </div>
        
        <div className="flex-1 bb flex wrap flex-column">
          {/* <TextBox cx="w-100 pl-s flex-1" border="bb" firstLevel="h2" secondLevel="i" thirdLevel="p" cx="" firstContent={title} secondContent="News" thirdContent={date}/> */}

        <div className="flex flex-3 wrap">
          <ReactMarkdown className="pa-m items-top lh-m">{description}</ReactMarkdown>
          <div className="align-self-end">
          {/* Links */}
          {links ? 
            links.map((link, index) => (
              <a className="flex external-link w-100 pb-m pl-m pt-s" href={link} >
                {link}
              </a>
              ) 
              )
              : 
              ""
            }
          </div>
        </div>
        
        </div>
        
      </div>


    </div>

    





  );
}
}

export default CV;
